import React from "react";


function Footer() {


  return (
    <div>
      <div className="aEosk">
        <div className="vfdGk">
          <div>Investor Relations</div>
          <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/plus.svg" alt="" />
        </div>
        <div className="vfdGk">
          <div>More about Paytm</div>
          <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/plus.svg" alt="" />
        </div>
        <div className="vfdGk">
          <div>Company</div>
          <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/plus.svg" alt="" />
        </div>
        <div className="vfdGk">
          <div>Career</div>
          <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/plus.svg" alt="" />
        </div>
        <div className="vfdGk">
          <div>Recharge & pay bills</div>
          <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/plus.svg" alt="" />
        </div>
        <div className="vfdGk">
          <div>Pay Loan EMI, Insurance Premiums & Education Fee</div>
          <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/plus.svg" alt="" />
        </div>
        <div className="vfdGk">
          <div>Book Travel & Entertainment</div>
          <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/plus.svg" alt="" />
        </div>
        <div className="vfdGk">
          <div>Investments & Miscellaneous</div>
          <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/plus.svg" alt="" />
        </div>
        <div className="vfdGk">
          <div>Loans and Credit Cards</div>
          <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/plus.svg" alt="" />
        </div>
        <div className="vfdGk">
          <div>Financial Tools & Calculators</div>
          <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/plus.svg" alt="" />
        </div>


      </div>
      <div className="skDv2h"></div>
      <div className="Zo9xa">
        <div>© 2025 Paytm</div>
        <div className="aYvkk">
          Follow Us
          <div>
            <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/social/facebook.svg" alt="" />
          </div>
          <div>
            <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/social/twitter.svg" alt="" />
          </div>
          <div>
            <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/social/youtube.svg" alt="" />
          </div>
          <div>
            <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/social/linkedin.svg" alt="" />
          </div>
          <div>
            <img src="https://pwebassets.paytm.com/commonwebassets/paytmweb/footer/images/social/instagram.svg" alt="" />
          </div>

        </div>
      </div>

      <div className="dJXTa"></div>
    </div>
  )

}
export default Footer;